import React, { useMemo } from 'react'

import { PaginatedTable, PaginatedTableCallbacks, useTableUrlSync } from '../common'
import { SuppliersAdvancedSearch } from './'
import { SupplierFilters } from './filters'
import { SuppliersTable } from './collectionTable'
import { JsonSupplier, Supplier } from '../../models'
import { getSuppliers } from '../../api'

const defaultSearchState = {
    name: '',
    phone: '',
    fax: '',
    street: '',
    city: '',
    zip: '',
    state: '',
    country: '',
}

export const SuppliersLanding = () => {
    const tableUrlSync = useTableUrlSync(
        ['status', 'supplier_substatus_code', 'vendorCode'],
        Object.keys(defaultSearchState)
    )
    const defaultAdvancedSearchState = useMemo(
        () => ({
            ...defaultSearchState,
            ...tableUrlSync.defaultAdvancedSearch,
        }),
        [JSON.stringify(tableUrlSync.defaultAdvancedSearch)]
    )

    return (
        <PaginatedTable<Supplier, JsonSupplier>
            getData={(params) => getSuppliers({ ...params })}
            Filters={SupplierFilters}
            redirectLink={{
                to: '/suppliers/add',
                text: 'Create New Supplier',
            }}
            AdvancedSearchComponent={SuppliersAdvancedSearch}
            defaultAdvancedSearchState={defaultAdvancedSearchState}
            defaultFilters={tableUrlSync.defaultFilters}
            defaultPage={tableUrlSync.defaultPage}
            onParamsChange={tableUrlSync.onParamsChange}
            modelConstructor={(json: JsonSupplier) => new Supplier(json)}
            disableSearch={true}
            Table={(suppliers: Supplier[], callbacks: PaginatedTableCallbacks) => (
                <SuppliersTable
                    callbacks={callbacks}
                    resources={{ suppliers }}
                />
            )}
            title="Suppliers"
        />
    )
}
